import { APP_URL, LOGOUT_TYPE } from '../AppConstants';

const { MEMBER_PORTAL_HOST, MEMBER_PORTAL_LOGOUT_PATH } = APP_URL;

/**
 * @typedef {'SIGNOUT' | 'IDLE' | 'MAX_SESSION'} LOGOUT_TYPE
 */

/**
 * @description Get the logout URL with logout reason and encoded ctx.
 * @param {LOGOUT_TYPE} logoutType
 * @param {string} ctxQueryString - The encoded ctx query string.
 * @returns {string} - The logout URL.
 */
const getLogoutUrl = (logoutType, ctxQueryString) => {
    let signoutReason;
    switch (logoutType) {
        case LOGOUT_TYPE.idle:
            signoutReason = 'inactive';
            break;
        case LOGOUT_TYPE.maxSession:
            signoutReason = 'session';
            break;
        case LOGOUT_TYPE.signout:
        default:
            signoutReason = 'sign-out';
            break;
    }

    let params = { sign_out: signoutReason };
    if (ctxQueryString) {
        params.ctx = ctxQueryString;
    }
    const queryParams = new URLSearchParams(params).toString();

    return `${MEMBER_PORTAL_HOST}${MEMBER_PORTAL_LOGOUT_PATH}/?${queryParams}`;
};

export default getLogoutUrl;
